import React, { useEffect, useMemo } from 'react';
import debounce from 'lodash/debounce';
import { InputAdornment, TextField, Tooltip } from '@barracuda-internal/bds-core-v2';
import Close from '@barracuda-internal/bds-core-v2/dist/Icons/Core/Close';

interface SearchFieldProps {
	setSearch: (search: string) => void;
	searchText: string;
	setSearchText: (searchText: string) => void;
	label?: string;
}

export default function SearchField({
	setSearch,
	searchText,
	setSearchText,
	label = '',
}: SearchFieldProps): React.ReactElement {
	const [showTooltip, setShowTooltip] = React.useState(false);

	const debouncedUpdateSearch = useMemo(
		() => debounce((val: string) => setSearch(val.trim()), 300),
		[setSearch]
	);

	useEffect(() => {
		return () => {
			debouncedUpdateSearch.cancel();
		};
	}, [debouncedUpdateSearch]);

	const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
		const val = event.target.value;
		setSearchText(val);
		debouncedUpdateSearch(val);
	};

	const helperText = `Joe or <text> where text can be policy name`;

	return (
		<Tooltip
			title={helperText}
			arrow
			open={showTooltip}
		>
			<div>
				<TextField
					fullWidth
					size="small"
					label={label}
					onChange={handleSearch}
					onFocus={() => setShowTooltip(true)}
					onBlur={() => setShowTooltip(false)}
					value={searchText}
					variant="outlined"
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<Close
									fontSize="small"
									sx={{ cursor: 'pointer' }}
									onClick={() => {
										setSearch('');
										setSearchText('');
									}}
								/>
							</InputAdornment>
						),
					}}
				/>
			</div>
		</Tooltip>
	);
}